import Prose from 'components/atomic/atoms/prose'

const SharedWrapper = ({ children }) => <Prose>{children}</Prose>

export default SharedWrapper
